import { concat } from '../../helpers/common'

const MODULE_NAME = 'CHOICES/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_FACEBOOK_CLIENT_APPS = concat(MODULE_NAME, 'GET_FACEBOOK_CLIENT_APPS')
export const GET_FACEBOOK_CLIENT_APPS_SUCCESS = concat(MODULE_NAME, 'GET_FACEBOOK_CLIENT_APPS_SUCCESS')
export const GET_FACEBOOK_CLIENT_APPS_FAILURE = concat(MODULE_NAME, 'GET_FACEBOOK_CLIENT_APPS_FAILURE')
export const CLEAR_GET_FACEBOOK_CLIENT_APPS = concat(MODULE_NAME, 'CLEAR_GET_FACEBOOK_CLIENT_APPS')

export const GET_CHOICES_GEOLOCATIONS = concat(MODULE_NAME, 'GET_CHOICES_GEOLOCATIONS')
export const GET_CHOICES_GEOLOCATIONS_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_GEOLOCATIONS_SUCCESS')
export const GET_CHOICES_GEOLOCATIONS_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_GEOLOCATIONS_FAILURE')
export const CLEAR_CHOICES_GEOLOCATIONS = concat(MODULE_NAME, 'CLEAR_CHOICES_GEOLOCATIONS')

export const GET_CHOICES_COUNTRIES = concat(MODULE_NAME, 'GET_CHOICES_COUNTRIES')
export const GET_CHOICES_COUNTRIES_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_COUNTRIES_SUCCESS')
export const GET_CHOICES_COUNTRIES_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_COUNTRIES_FAILURE')

export const GET_CHOICES_INTERESTS = concat(MODULE_NAME, 'GET_CHOICES_INTERESTS')
export const GET_CHOICES_INTERESTS_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_INTERESTS_SUCCESS')
export const GET_CHOICES_INTERESTS_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_INTERESTS_FAILURE')
export const CLEAR_CHOICES_INTERESTS = concat(MODULE_NAME, 'CLEAR_CHOICES_INTERESTS')

export const GET_CHOICES_LANGUAGES = concat(MODULE_NAME, 'GET_CHOICES_LANGUAGES')
export const GET_CHOICES_LANGUAGES_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_LANGUAGES_SUCCESS')
export const GET_CHOICES_LANGUAGES_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_LANGUAGES_FAILURE')

export const GET_CHOICES_PIXELS = concat(MODULE_NAME, 'GET_CHOICES_PIXELS')
export const GET_CHOICES_PIXELS_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_PIXELS_SUCCESS')
export const GET_CHOICES_PIXELS_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_PIXELS_FAILURE')
export const CLEAR_CHOICES_PIXELS = concat(MODULE_NAME, 'CLEAR_CHOICES_PIXELS')

export const GET_CHOICES_CTA = concat(MODULE_NAME, 'GET_CHOICES_CTA')
export const GET_CHOICES_CTA_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_CTA_SUCCESS')
export const GET_CHOICES_CTA_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_CTA_FAILURE')
export const CLEAR_CHOICES_CTA = concat(MODULE_NAME, 'CLEAR_CHOICES_CTA')

export const GET_CHOICES_CTA_BY_GOAL = concat(MODULE_NAME, 'GET_CHOICES_CTA_BY_GOAL')
export const GET_CHOICES_CTA_BY_GOAL_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_CTA_BY_GOAL_SUCCESS')
export const GET_CHOICES_CTA_BY_GOAL_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_CTA_BY_GOAL_FAILURE')
export const CLEAR_CHOICES_CTA_BY_GOAL = concat(MODULE_NAME, 'CLEAR_CHOICES_CTA_BY_GOAL')

export const GET_CHOICES_ACTIONS = concat(MODULE_NAME, 'GET_CHOICES_ACTIONS')
export const GET_CHOICES_ACTIONS_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_ACTIONS_SUCCESS')
export const GET_CHOICES_ACTIONS_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_ACTIONS_FAILURE')

export const GET_CHOICES_ALLOCATION_UNITS = concat(MODULE_NAME, 'GET_CHOICES_ALLOCATION_UNITS')
export const GET_CHOICES_ALLOCATION_UNITS_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_ALLOCATION_UNITS_SUCCESS')
export const GET_CHOICES_ALLOCATION_UNITS_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_ALLOCATION_UNITS_FAILURE')

export const GET_CHOICES_BEHAVIOURS = concat(MODULE_NAME, 'GET_CHOICES_BEHAVIOURS')
export const GET_CHOICES_BEHAVIOURS_SUCCESS = concat(MODULE_NAME, 'GET_CHOICES_BEHAVIOURS_SUCCESS')
export const GET_CHOICES_BEHAVIOURS_FAILURE = concat(MODULE_NAME, 'GET_CHOICES_BEHAVIOURS_FAILURE')
export const CLEAR_GET_CHOICES_BEHAVIOURS = concat(MODULE_NAME, 'CLEAR_GET_CHOICES_BEHAVIOURS')

export const GET_CUSTOM_CONVERSIONS = concat(MODULE_NAME, 'GET_CUSTOM_CONVERSIONS')
export const GET_CUSTOM_CONVERSIONS_SUCCESS = concat(MODULE_NAME, 'GET_CUSTOM_CONVERSIONS_SUCCESS')
export const GET_CUSTOM_CONVERSIONS_FAILURE = concat(MODULE_NAME, 'GET_CUSTOM_CONVERSIONS_FAILURE')
export const CLEAR_GET_CUSTOM_CONVERSIONS = concat(MODULE_NAME, 'CLEAR_GET_CUSTOM_CONVERSIONS')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

export function getChoicesGeolocations(params) {
  return { type: GET_CHOICES_GEOLOCATIONS, params }
}

export function getChoicesGeolocationsSuccess(choicesData) {
  return { type: GET_CHOICES_GEOLOCATIONS_SUCCESS, choicesData }
}

export function getChoicesGeolocationsFailure(error) {
  return { type: GET_CHOICES_GEOLOCATIONS_FAILURE, error }
}

export function clearChoicesGeolocations() {
  return { type: CLEAR_CHOICES_GEOLOCATIONS }
}

export function getChoicesCountries() {
  return { type: GET_CHOICES_COUNTRIES }
}

export function getChoicesCountriesSuccess(choicesData) {
  return { type: GET_CHOICES_COUNTRIES_SUCCESS, choicesData }
}

export function getChoicesCountriesFailure(error) {
  return { type: GET_CHOICES_COUNTRIES_FAILURE, error }
}

export function getChoicesInterests(params) {
  return { type: GET_CHOICES_INTERESTS, params }
}

export function getChoicesInterestsSuccess(choicesData) {
  return { type: GET_CHOICES_INTERESTS_SUCCESS, choicesData }
}

export function getChoicesInterestsFailure(error) {
  return { type: GET_CHOICES_INTERESTS_FAILURE, error }
}

export function clearChoicesInterests() {
  return { type: CLEAR_CHOICES_INTERESTS }
}

export function getChoicesLanguages(params) {
  return { type: GET_CHOICES_LANGUAGES, params }
}

export function getChoicesLanguagesSuccess(choicesData) {
  return { type: GET_CHOICES_LANGUAGES_SUCCESS, choicesData }
}

export function getChoicesLanguagesFailure(error) {
  return { type: GET_CHOICES_LANGUAGES_FAILURE, error }
}

export function getChoicesPixels(params, platform) {
  return { type: GET_CHOICES_PIXELS, params, platform }
}

export function getChoicesPixelsSuccess(choicesData) {
  return { type: GET_CHOICES_PIXELS_SUCCESS, choicesData }
}

export function getChoicesPixelsFailure(error) {
  return { type: GET_CHOICES_PIXELS_FAILURE, error }
}

export function clearChoicesPixels() {
  return { type: CLEAR_CHOICES_PIXELS }
}

export function getChoicesCTA(params) {
  return { type: GET_CHOICES_CTA, params }
}

export function getChoicesCTASuccess(choicesData) {
  return { type: GET_CHOICES_CTA_SUCCESS, choicesData }
}

export function getChoicesCTAFailure(error) {
  return { type: GET_CHOICES_CTA_FAILURE, error }
}

export function clearChoicesCTA() {
  return { type: CLEAR_CHOICES_CTA }
}

export function getChoicesCTAByGoal(params) {
  return { type: GET_CHOICES_CTA_BY_GOAL, params }
}

export function getChoicesCTAByGoalSuccess(choicesData, goal) {
  return { type: GET_CHOICES_CTA_BY_GOAL_SUCCESS, choicesData, goal }
}

export function getChoicesCTAByGoalFailure(error) {
  return { type: GET_CHOICES_CTA_BY_GOAL_FAILURE, error }
}

export function clearChoicesCTAByGoal() {
  return { type: CLEAR_CHOICES_CTA_BY_GOAL }
}

export function getChoicesActions(params) {
  return { type: GET_CHOICES_ACTIONS, params }
}

export function getChoicesActionsSuccess(choicesData) {
  return { type: GET_CHOICES_ACTIONS_SUCCESS, choicesData }
}

export function getChoicesActionsFailure(error) {
  return { type: GET_CHOICES_ACTIONS_FAILURE, error }
}

export function getChoicesAllocationUnits(params) {
  return { type: GET_CHOICES_ALLOCATION_UNITS, params }
}

export function getChoicesAllocationUnitsSuccess(choicesData) {
  return { type: GET_CHOICES_ALLOCATION_UNITS_SUCCESS, choicesData }
}

export function getChoicesAllocationUnitsFailure(error) {
  return { type: GET_CHOICES_ALLOCATION_UNITS_FAILURE, error }
}

// Get facebook client apps
export function getFacebookClientApps(params) {
  return { type: GET_FACEBOOK_CLIENT_APPS, params }
}

export function getFacebookClientAppsSuccess(data) {
  return { type: GET_FACEBOOK_CLIENT_APPS_SUCCESS, data }
}

export function getFacebookClientAppsFailure(error) {
  return { type: GET_FACEBOOK_CLIENT_APPS_FAILURE, error }
}

export function clearGetFacebookClientApps() {
  return { type: CLEAR_GET_FACEBOOK_CLIENT_APPS }
}

// Get choices behaviours
export function getChoicesBehaviours(params) {
  return { type: GET_CHOICES_BEHAVIOURS, params }
}

export function getChoicesBehavioursSuccess(data) {
  return { type: GET_CHOICES_BEHAVIOURS_SUCCESS, data }
}

export function getChoicesBehavioursFailure(error) {
  return { type: GET_CHOICES_BEHAVIOURS_FAILURE, error }
}

export function clearGetChoicesBehaviours() {
  return { type: CLEAR_GET_CHOICES_BEHAVIOURS }
}

// Get custom conversions
export function getCustomConversions(params) {
  return { type: GET_CUSTOM_CONVERSIONS, params }
}

export function getCustomConversionsSuccess(data) {
  return { type: GET_CUSTOM_CONVERSIONS_SUCCESS, data }
}

export function getCustomConversionsFailure(error) {
  return { type: GET_CUSTOM_CONVERSIONS_FAILURE, error }
}

export function clearGetCustomConversions() {
  return { type: CLEAR_GET_CUSTOM_CONVERSIONS }
}
